import Axios from "axios";
import {
    SET_PORT_LIST,
    UNSET_PORT_LIST
  } from "@/store/mutation-types";
import { saveUpdatePort, getPortList, generatePortCode } from "@/store/api";
// initial state
const state = {
  getPortList: [],
};

const getters = {
  getPortList(state) {
    return state.getPortList;
  },
};

const mutations = {
  [SET_PORT_LIST](state, data) {
    state.getPortList = data;
  },
  [UNSET_PORT_LIST](state) {
    state.getPortList = [];
  }
};

const actions = {

  saveUpdatePort({ commit }, data) {
    commit("SET_LOADING", {color: "primary"});
    return new Promise((resolve, reject) => {
      Axios.post(saveUpdatePort, data)
        .then(function (response) {
          resolve(response);
        })
        .catch(function (error) {

          reject(error);
        })
        .then((always) => {
            commit("UNSET_LOADING");
        });
    });
  },

  getPortList({ commit }, data) {
    return new Promise((resolve, reject) => {
      Axios.post(getPortList, data)
        .then(function (response) {
          commit('SET_PORT_LIST', response.data.data)
          resolve(response);
        })
        .catch(function (error) {
          commit('UNSET_PORT_LIST')
          reject(error);
        })
        .then((always) => {
        });
    });
  },

  getGeneratedPortCode({ commit }) {
    return new Promise((resolve, reject) => {
      Axios.get(generatePortCode)
        .then((response) => {
          resolve(response.data.code);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },


};

export default {
  state,
  getters,
  actions,
  mutations,
};
